import { observable, makeObservable } from "mobx";

export default class LoginStore {
  loading;

  constructor() {
    makeObservable(this, {
      loading: observable,
    });
  }
}
